// src/components/StandardDeductionQuestions.js
import React from 'react';
import { HelpCircle } from 'react-feather';

function StandardDeductionQuestions({ formData, onDataChange }) {
  const { filingStatus } = formData;

  // Determine if spouse-related questions should be shown
  const showSpouseQuestions = filingStatus === 'Married Filing Jointly' || filingStatus === 'Married Filing Separately';

  return (
    <div className="form-section">
      <div className="content-box-header">
        <h2><HelpCircle size={20} className="icon-orange" /> Standard Deduction Questions</h2>
      </div>
      <div className="deduction-questions-container">
        {/* --- Questions for the primary taxpayer --- */}
        <div className="form-group checkbox-group">
          <input type="checkbox" id="isOver65" name="isOver65" checked={formData.isOver65} onChange={onDataChange} />
          <label htmlFor="isOver65">You were born before January 2, 1959</label>
        </div>
        <div className="form-group checkbox-group">
          <input type="checkbox" id="isBlind" name="isBlind" checked={formData.isBlind} onChange={onDataChange} />
          <label htmlFor="isBlind">You are legally blind</label>
        </div>

        {/* --- Conditionally rendered questions for the spouse --- */}
        {showSpouseQuestions && (
          <>
            <div className="form-group checkbox-group">
              <input type="checkbox" id="spouseIsOver65" name="spouseIsOver65" checked={formData.spouseIsOver65} onChange={onDataChange} />
              <label htmlFor="spouseIsOver65">Your spouse was born before January 2, 1959</label>
            </div>
            <div className="form-group checkbox-group">
              <input type="checkbox" id="spouseIsBlind" name="spouseIsBlind" checked={formData.spouseIsBlind} onChange={onDataChange} />
              <label htmlFor="spouseIsBlind">Your spouse is legally blind</label>
            </div>
          </>
        )}

        {/* --- Existing questions --- */}
        <div className="form-group checkbox-group">
          <input type="checkbox" id="canBeClaimedAsDependent" name="canBeClaimedAsDependent" checked={formData.canBeClaimedAsDependent} onChange={onDataChange} />
          <label htmlFor="canBeClaimedAsDependent">Someone can claim you as a dependent</label>
        </div>
        <div className="form-group checkbox-group">
          <input type="checkbox" id="isDualStatusAlien" name="isDualStatusAlien" checked={formData.isDualStatusAlien} onChange={onDataChange} />
          <label htmlFor="isDualStatusAlien">You were a dual-status alien</label>
        </div>
        {filingStatus === 'Married Filing Separately' && (
          <div className="form-group checkbox-group">
            <input type="checkbox" id="spouseItemizes" name="spouseItemizes" checked={formData.spouseItemizes} onChange={onDataChange} />
            <label htmlFor="spouseItemizes">Your spouse itemizes on a separate return</label>
          </div>
        )}
      </div>
    </div>
  );
}

export default StandardDeductionQuestions;
